{
  "version": 1,
  "asset_id": "0c89da6f-ddb5-45d0-9328-4713375fa656",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/0c89da6f-ddb5-45d0-9328-4713375fa656/avcilar-hizli-elektrikci-7-24-dukkan-7.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/0c89da6f-ddb5-45d0-9328-4713375fa656/avcilar-hizli-elektrikci-7-24-dukkan-7.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-7.jpg",
  "size": 524894,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:48Z"
}
